import { render } from "./MyReviewPage.vue?vue&type=template&id=2bb4e7cd"
import script from "./MyReviewPage.vue?vue&type=script&lang=js"
export * from "./MyReviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__